import { StyleSheet } from 'react-native';
import {
  labelGray,
  disabledBackgroundColor,
  white,
  fontFamilyRegular,
  fontSizeMedium,
  fontSizeExtraSmall,
  textInputBorderRadius,
  textInputBorderStyle,
  textInputBorderWidth,
  textInputPadding,
  textInputLabelPadding,
  errorRed,
  inputBlurGrey,
  focusBlue,
  transparent,
  darkestGrey,
} from '../../../constants/palette';

export default StyleSheet.create({
  wrapper: {
    marginBottom: 10,
  },
  container: {
    flex: 1,
    marginBottom: 5,
  },
  blurInputContainer: {
    backgroundColor: darkestGrey,
    // borderColor: inputBlurGrey,
    borderRadius: textInputBorderRadius,
    borderStyle: textInputBorderStyle,
    borderWidth: textInputBorderWidth,
  },
  disabledInputContainer: {
    backgroundColor: darkestGrey,
    borderColor: disabledBackgroundColor,
    borderRadius: textInputBorderRadius,
    borderWidth: textInputBorderWidth,
    borderStyle: textInputBorderStyle,
  },
  errorInputContainer: {
    backgroundColor: darkestGrey,
    borderColor: errorRed,
    borderRadius: textInputBorderRadius,
    borderStyle: textInputBorderStyle,
    borderWidth: textInputBorderWidth,
  },
  focusInputContainer: {
    backgroundColor: darkestGrey,
    borderColor: focusBlue,
    borderRadius: textInputBorderRadius,
    borderStyle: textInputBorderStyle,
    borderWidth: textInputBorderWidth,
  },
  blurInputContainerWithImage: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: darkestGrey,
    // borderColor: inputBlurGrey,
    borderRadius: textInputBorderRadius,
    borderStyle: textInputBorderStyle,
    borderWidth: textInputBorderWidth,
  },
  disabledInputContainerWithImage: {
    backgroundColor: darkestGrey,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderColor: disabledBackgroundColor,
    borderRadius: textInputBorderRadius,
    borderWidth: textInputBorderWidth,
    borderStyle: textInputBorderStyle,
  },
  errorInputContainerWithImage: {
    backgroundColor: darkestGrey,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderColor: errorRed,
    borderRadius: textInputBorderRadius,
    borderStyle: textInputBorderStyle,
    borderWidth: textInputBorderWidth,
  },
  focusInputContainerWithImage: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: darkestGrey,
    borderColor: focusBlue,
    borderRadius: textInputBorderRadius,
    borderStyle: textInputBorderStyle,
    borderWidth: textInputBorderWidth,
  },
  label: {
    color: labelGray,
    fontFamilyRegular,
    fontSize: fontSizeExtraSmall,
    paddingBottom: textInputLabelPadding,
  },
  errorMessageText: {
    color: errorRed,
    fontFamilyRegular,
    fontSize: fontSizeExtraSmall,
    paddingBottom: 10,
  },
  disabledTextInput: {
    backgroundColor: darkestGrey,
    borderColor: disabledBackgroundColor,
    borderRadius: textInputBorderRadius,
    borderWidth: textInputBorderWidth,
    color: white,
    flex: 1,
    fontFamilyRegular,
    fontSize: fontSizeMedium,
    padding: textInputPadding,
  },
  textInput: {
    backgroundColor: darkestGrey,
    // borderColor: inputBlurGrey,
    // borderStyle: textInputBorderStyle,
    // borderWidth: textInputBorderWidth,
    borderRadius: textInputBorderRadius,
    color: white,
    fontFamily: fontFamilyRegular,
    fontSize: fontSizeMedium,
    padding: textInputPadding,
    outlineColor: transparent,
    outlineStyle: textInputBorderStyle,
    // width: 200  this makes it work on mobile but we need to set it to be dynamic
  },
  imageStyle: {
    padding: 10,
    margin: 5,
    height: 20,
    width: 25,
    resizeMode: 'stretch',
    alignItems: 'center',
  },
});
